module.exports = __webpack_public_path__ + "media/images/icons/chart-344a2d97fce6953ba17649e325dd2b4c.svg";